
// import  roles  from "../../../../App";

export const transactionsColumns = [
  { name: "id", title: "ID", sortable: true },
  { name: "payable_type", title: "PAYABLE_TYPE", sortable: true,acceptedRoles:["ROLE_SUPER_ADMIN"] },
  { name: "payable_id", title: "PAYABLE", sortable: true },
  { name: "wallet_id", title: "WALLET", sortable: true },
  { name: "type", title: "TYPE", sortable: true },
  { name: "amount", title: "AMOUNT", sortable: false },
  {
    template: (d) => `${d.confirmed}`,
    title: "CONFIRMED",
    sortable: true,
  },
  // {
  //   template: (d) => JSON.stringify(d),
  //   title: "META",
  //   sortable: false,
  // },
  { name: "uuid", title: "uuid", sortable: false },
  { name: "created_at", title: "CREATED_AT", sortable: true, type: "date" },
  { name: "updated_at", title: "UPDATED_AT", sortable: true, type: "date" },
];
